<template>
  <div class="list-group-item-inner d-flex align-items-center justify-content-end">
    <div class="preview-col d-flex align-items-center">
      <slot name="preview" />
    </div>
    <div class="first-col d-inline-flex align-items-center justify-content-center">
      <slot name="first" />
    </div>
    <div class="toggle-col d-inline-flex align-items-center">
      <slot name="toggle" />
    </div>
    <div class="flex-grow-1" ref="umr" v-b-tooltip.hover :title="truncated.umr ? $props.item.umr : ''">{{ $props.item.umr }}</div>
    <div class="rc-col bdx-col" ref="risk_code" v-b-tooltip.hover :title="truncated.risk_code ? $props.item.risk_code : ''">{{ $props.item.risk_code }}</div>
    <div class="cc-col bdx-col" ref="cat_code" v-b-tooltip.hover :title="truncated.cat_code ? $props.item.cat_code : ''">{{ $props.item.cat_code }}</div>
    <div class="sn-col bdx-col" ref="section_no" v-b-tooltip.hover :title="truncated.section_no ? $props.item.section_no : ''">{{ $props.item.section_no }}</div>
    <div class="lu-col bdx-col" ref="lead_underwriter" v-b-tooltip.hover :title="truncated.lead_underwriter ? $props.item.lead_underwriter : ''">{{ $props.item.lead_underwriter }}</div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { has } from 'lodash-es'

import { useTruncatedTooltip } from '@composables'

export default defineComponent({
  name: 'BDXStatusPendingManagerListItem',
  props: {
    item: {
      type: Object,
      required: true,
      validator: (value) =>
        ['id', 'umr', 'risk_code', 'cat_code', 'section_no'].every((item) =>
          has(value, item)
        )
    }
  },
  setup(props) {
    const { truncated, umr, risk_code, cat_code, section_no, lead_underwriter } =
      useTruncatedTooltip(
        ['umr', 'risk_code', 'cat_code', 'section_no', 'lead_underwriter'],
        () => props.item
      )

    return { truncated, umr, risk_code, cat_code, section_no, lead_underwriter }
  }
})
</script>

<style scoped>
.bdx-manager-list .list-group-item-inner > div.preview-col {
  min-width: 44px;
  width: 44px;
}

.bdx-manager-list .list-group-item-inner > div.first-col {
  min-width: 30px;
  width: 30px;
  margin-right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.bdx-manager-list .list-group-item-inner > div >>> .custom-checkbox {
  width: 20px;
  margin-left: 0;
}

.bdx-manager-list .list-group-item-inner > div >>> .custom-checkbox > label {
  padding-left: 0;
  margin-bottom: 0;
}

.bdx-manager-list .list-group-item-inner > div.toggle-col {
  min-width: 50px;
  width: 50px;
}

.bdx-manager-list .list-group-item-inner > div.flex-grow-1 {
  min-width: 160px;
}

.bdx-manager-list .list-group-item-inner > div.flex-grow-1,
.bdx-manager-list .list-group-item-inner > div.bdx-col {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
